import { Validate } from '@edgvr-front/util/validate';
import { CompanyHostDeviceId, CompanyName } from '../interface';
import { companyHostDeviceId, companyName } from '../schema';

export class CompanyHostDeviceDeleteVO {
  private static configValidation = Validate.compile(
    CompanyHostDeviceDeleteVO.configValidationSchema()
  );

  constructor(readonly value: CompanyHostDeviceDelete) {
    Validate.assert(CompanyHostDeviceDeleteVO.configValidation, this.value);
  }

  private static configValidationSchema() {
    return {
      type: 'object',
      required: ['companyName', 'deviceId'],
      properties: {
        companyName,
        deviceId: companyHostDeviceId,
      },
      additionalProperties: false,
    };
  }
}

interface CompanyHostDeviceDelete {
  companyName: CompanyName;
  deviceId: CompanyHostDeviceId;
}
